import React, { useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactDOM from "react-dom";
import Cropper from "react-easy-crop";
// import './styles.css'
import {
  Card,
  ButtonCommonTopNew,
  ButtonCommonTopGrey,
} from "../../pages/Theme";
import { apiUrl, apiMainUrl, serverUrl } from "../Helpers/Config";
import axios from "axios";
import {
  setUserPhoto,
  setUserCover,
  setUserPinned,
} from "../../redux/actions/auth";
import { useEffect } from "react";
import { tokenAuthorize } from "../Helpers/Common";
import ButtonCommon from "../../components/Button/ButtonCommon";
import Button from "../Button/Button";

const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (error) => reject(error));
    image.setAttribute("crossOrigin", "anonymous"); // needed to avoid cross-origin issues on CodeSandbox
    image.src = url;
  });

function getRadianAngle(degreeValue) {
  return (degreeValue * Math.PI) / 180;
}

/**
 * Returns the new bounding area of a rotated rectangle.
 */
function rotateSize(width, height, rotation) {
  const rotRad = getRadianAngle(rotation);

  return {
    width:
      Math.abs(Math.cos(rotRad) * width) + Math.abs(Math.sin(rotRad) * height),
    height:
      Math.abs(Math.sin(rotRad) * width) + Math.abs(Math.cos(rotRad) * height),
  };
}
async function getMimeTypeFromBlobUrl(blobUrl) {
  const response = await fetch(blobUrl);
  const blob = await response.blob();
  return blob.type; // e.g., "image/png" or "image/jpeg"
}

async function getCroppedImg(
  imageSrc,
  pixelCrop,
  rotation = 0,
  flip = { horizontal: false, vertical: false }
) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  if (!ctx) {
    return null;
  }

  const rotRad = getRadianAngle(rotation);

  // calculate bounding box of the rotated image
  const { width: bBoxWidth, height: bBoxHeight } = rotateSize(
    image.width,
    image.height,
    rotation
  );

  // set canvas size to match the bounding box
  canvas.width = bBoxWidth;
  canvas.height = bBoxHeight;

  // translate canvas context to a central location to allow rotating and flipping around the center
  ctx.translate(bBoxWidth / 2, bBoxHeight / 2);
  ctx.rotate(rotRad);
  ctx.scale(flip.horizontal ? -1 : 1, flip.vertical ? -1 : 1);
  ctx.translate(-image.width / 2, -image.height / 2);

  // draw rotated image
  ctx.drawImage(image, 0, 0);

  // croppedAreaPixels values are bounding box relative
  // extract the cropped image using these values
  const data = ctx.getImageData(
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height
  );

  // set canvas width to final desired crop size - this will clear existing context
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;

  // paste generated rotate image at the top left corner
  ctx.putImageData(data, 0, 0);

  // As Base64 string
  // return canvas.toDataURL('image/jpeg');

  // As a blob
  const mimeType = await getMimeTypeFromBlobUrl(imageSrc);
  return new Promise((resolve, reject) => {
    canvas.toBlob((file) => {
      resolve(URL.createObjectURL(file));
    }, mimeType);
  });
}
async function blobUrlToFile(blobUrl, filename) {
  const response = await fetch(blobUrl); // fetch the blob data from blob URL
  const blob = await response.blob(); // get real Blob
  const file = new File([blob], filename, { type: blob.type });
  return file;
}

const ModalProfile = ({
  show,
  setShow,
  imgSrc,
  editCover,
  editBanner,
  seteditCoverImage,
  setshowModalEditCover,
  imgCommunity,
  groupId,
  setgroupCardImage,
  editPinned = false,
}) => {
  const dispatch = useDispatch();

  const [dataShow, setdataShow] = useState(false);
  const userProfile = useSelector((state) => state.auth.user);

  // useEffect(() => {
  //     setdataShow(show)
  // }, [show])

  const showHideModal = show
    ? "fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 block modelIndex"
    : "fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 hidden";

  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        imgSrc,
        croppedAreaPixels,
        rotation
      );
      setCroppedImage(croppedImage);
      if (editBanner == true || editCover == true || imgCommunity === true) {
        getBlobData(croppedImage);
      }
      //   if (editCover == false && editBanner == false) {
      //     var blob = dataURItoBlob(croppedImage);
      //     const formData = new FormData();

      //     const xhr = new XMLHttpRequest();
      //     xhr.open("GET", croppedImage, true);
      //     xhr.responseType = "blob";

      //     xhr.onload = () => {
      //       formData.append("file", xhr.response, "filename.png");
      //       updateProfilePhoto(formData);
      //     };
      //     xhr.send();
      //   }
      if (editCover == false && editBanner == false) {
        const file = await blobUrlToFile(croppedImage, imgSrc.name); // originalFile.name is the uploaded filename

        // Append to FormData
        const formData = new FormData();
        formData.append("file", file); // keeps original filename

        // Upload
        updateProfilePhoto(formData);
      }
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels, rotation]);

  function dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(",")[0].indexOf("base64") >= 0)
      byteString = atob(dataURI.split(",")[1]);
    else byteString = unescape(dataURI.split(",")[1]);

    // separate out the mime component
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  }

  const getBlobData = (file) => {
    axios({
      method: "get",
      url: file, // blob url eg. blob:http://127.0.0.1:8000/e89c5d87-a634-4540-974c-30dc476825cc
      responseType: "blob",
    }).then(function (response) {
      var reader = new FileReader();
      reader.readAsDataURL(response.data);
      reader.onloadend = function () {
        var base64data = reader.result;
        updateProfilePhoto(base64data);
      };
    });
  };

  const removeCroppedImage = () => {
    setShow(false);
  };

  const updateProfilePhoto = (fileObj) => {
    if (imgCommunity == true) {
      let data = {
        group_image: fileObj,
      };
      axios
        .put(serverUrl.GroupCardImage + groupId, data, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((resp) => {
          if (resp.status === 200) {
            setgroupCardImage(fileObj);
            setShow(false);
          }
        })
        .catch((err) => {
          tokenAuthorize(err?.response?.status);
          console.log(err);
          setShow(false);
        });
    }

    if (editCover == true) {
      setShow(false);
      setshowModalEditCover(false);
      seteditCoverImage(fileObj);
    }
    if (editBanner == true) {
      let dataImage = {
        file: fileObj,
      };
      if (fileObj != "") {
        axios
          .post(
            serverUrl.ProfilePinnedImage +
              "?profile_id=" +
              userProfile?.learner_profile_id,
            dataImage
            // { headers: { 'Content-Type': 'multipart/form-data' } }
          )
          .then((resp) => {
            if (resp.status === 200) {
              setshowModalEditCover(false);
              dispatch(setUserPinned(resp.data.photo));
              setShow(false);
            }
          })
          .catch((err) => {
            tokenAuthorize(err?.response?.status);
            console.log(err);
            setShow(false);
          });
      }
    }
    if (editCover == false && editBanner == false && imgCommunity != true) {
      axios
        .post(
          serverUrl.ProfileAvatar +
            "?profile_id=" +
            userProfile?.learner_profile_id,
          fileObj,
          { headers: { "Content-Type": "multipart/form-data" } }
        )
        .then((resp) => {
          if (resp.status === 200) {
            dispatch(setUserPhoto(resp.data.photo));
            setShow(false);
          }
        })
        .catch((err) => {
          tokenAuthorize(err?.response?.status);
          console.log(err);
          setShow(false);
        });
    }
  };

  return (
    <div className={showHideModal} onClick={(e) => e.stopPropagation()}>
      <div className="fixed inset-0 modelIndex flex items-center justify-center bg-black bg-opacity-50 px-4 py-6">
        <div
          className={`absolute cardBackgroundColor rounded-xl shadow-md p-4 image-editor max-w-full max-h-screen overflow-auto modal-popup-width`}
        >
          <div className="">
            <div className="crop-container mx-10">
              <Cropper
                image={imgSrc}
                crop={crop}
                zoom={zoom}
                cropShape={
                  editCover == true ||
                  editBanner == true ||
                  imgCommunity == true
                    ? ""
                    : "round"
                }
                aspect={
                  editPinned
                    ? 3 / 1
                    : editCover == true || editBanner == true
                    ? 5 / 1
                    : imgCommunity == true
                    ? 4 / 1
                    : 2 / 2
                }
                onCropChange={setCrop}
                onCropComplete={onCropComplete}
                onZoomChange={setZoom}
              />
            </div>
            <div className="controls">
              <input
                type="range"
                value={zoom}
                min={1}
                max={3}
                step={0.1}
                aria-labelledby="Zoom"
                onChange={(e) => {
                  setZoom(e.target.value);
                }}
                className="zoom-range"
              />
            </div>
          </div>
          <div className="flex gap-2 justify-end mx-6">
            <ButtonCommonTopNew
              className="px-5 border p-1.5 text-sm rounded-lg cursor-pointer"
              onClick={showCroppedImage}
              title="Apply"
            >
              Apply
            </ButtonCommonTopNew>
            <ButtonCommonTopGrey
              className="px-5 border p-1.5 text-sm rounded-lg cursor-pointer"
              onClick={removeCroppedImage}
              title="Cancel"
            >
              Cancel
            </ButtonCommonTopGrey>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalProfile;
